import { IAutomationObject } from "../../../types";

export interface IControlledCoolingOutletRelease extends IAutomationObject {
    outsideTemperature: number;
    setpointMaxOT: number;
    oTRelease: boolean;
    eXTRelease: boolean;
    eXTRequest: boolean;
    release: boolean;
}


export const schema = 'AutomationApps.Logics.Coolings.ControlledCoolingOutletRelease';


